var ClientStatus;
(function (ClientStatus) {
    ClientStatus[ClientStatus["Active"] = 1] = "Active";
    ClientStatus[ClientStatus["Inactive"] = 2] = "Inactive";
    ClientStatus[ClientStatus["ReadOnly"] = 3] = "ReadOnly";
    ClientStatus[ClientStatus["Deleted"] = 4] = "Deleted";
})(ClientStatus || (ClientStatus = {}));
export default ClientStatus;
